/** 监测链接 */
export {
  channel,
};

const channel = {
  value: {},
  children: {
    alias: {
      label: '渠道',
      type: 'input',
      value: '',
      extra_data: { channel_details: {}, games: [] },
      props: {
        style: {
          width: '200px',
        },
        placeholder: '请输入渠道',
      },
      rules: [
        { required: true, message: '请输入渠道', trigger: ['blur', 'change'] },
      ],
    },
  },
};
